import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchCatalogPage } from "../lib/api";
import type { CatalogFilters } from "../lib/types";

// Cursor-paginated catalog feed. The grid drives fetchNextPage as the user nears
// the end, so only the visible window (+ a little) is ever in memory or the DOM.
export function useCatalog(filters: CatalogFilters) {
  const query = useInfiniteQuery({
    queryKey: ["catalog", filters],
    queryFn: ({ pageParam }) => fetchCatalogPage(filters, pageParam),
    initialPageParam: null as string | null,
    getNextPageParam: (last) => last.nextCursor,
  });

  const items = query.data?.pages.flatMap((p) => p.items) ?? [];
  const total = query.data?.pages[0]?.total ?? 0;
  return { ...query, items, total };
}
